var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricityComsumption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 66,
    viewBox: "0 0 47 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4908 60.8524C13.4908 61.6859 13.8382 62.45 14.4633 63.0057L17.3114 65.3674C17.7979 65.7841 18.423 65.9925 19.0481 65.9925H27.9396C28.5647 65.9925 29.1897 65.7841 29.6762 65.3674L32.5244 63.0057C33.1495 62.45 33.4969 61.6858 33.4969 60.8524V55.6426H13.352L13.3516 60.8524H13.4908Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8554 0.141718C10.158 1.32256 1.47467 9.86656 0.154838 20.5644C-0.887422 29.9419 3.41969 38.3474 10.4355 43.071C12.3112 44.3212 13.4223 46.3359 13.4223 48.5585V50.5035H33.5671V48.6279C33.5671 46.4746 34.6089 44.3905 36.4153 43.1404C42.806 38.903 46.9741 31.6789 46.9741 23.4818C47.1131 9.65829 35.0958 -1.38663 20.8553 0.141594L20.8554 0.141718ZM33.498 23.4819L21.6891 39.3199C20.6473 40.7091 18.4935 39.7366 18.8409 38.0698L20.925 27.8585H15.0202C13.7002 27.8585 12.9361 26.3302 13.7002 25.2884L25.5092 9.45039C26.5509 8.06122 28.7048 9.03367 28.3573 10.7005L26.2733 20.9119H32.178C33.498 20.9114 34.2621 22.3704 33.498 23.4819Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityComsumption);
export default __webpack_public_path__ + "static/media/electricityComsumption.d04ed884caffe4580f6384de7d8cca80.svg";
export { ForwardRef as ReactComponent };